<div>
    <app-audi-text variant="order4" className="audi-type-normal" weight="bold" text="{{statusMessage}}"></app-audi-text>
    <!--info-->
    <div [hidden]="!infoLoaded">
        <br />
        <!--successful purchase-->
        <div [hidden]="!visibleElements['PaymentSuccess']">
            <app-audi-text variant="order4" className="audi-type-normal"
                text="Your Freeway Vehicle Plan has been added to your customer details, but it may take up to 24 hours to reflect on the system.">
            </app-audi-text>
            <br /><br />
            <div class="column__list" *ngIf="transaction">
                <div class="card__list">
                    <app-audi-text-input inputId="payment_quote_ref" label="Contract Number" value="{{transaction?.sapContractNumber}}" disabled="true" isRequired="true">
                    </app-audi-text-input>
                </div>
                <div class="card__list">
                    <app-audi-text-input inputId="payment_total" label="Total (incl. VAT)" value="R{{transaction?.newPlanTotalIncludingVat | number}}" disabled="true"
                        isRequired="true">
                    </app-audi-text-input>
                </div>
            </div>
            <app-audi-button text="View My Details" (click)="onViewMyDetails()" [disabled]="!ownerInfo">
            </app-audi-button>
            <br /><br />
            <app-audi-text variant="order4" className="audi-type-normal"
                text="You can download a copy of the Freeway contract for your records. A copy will also be emailed to the address provided.">
            </app-audi-text>
            <br /><br />
            <app-audi-button text="Download Contract" (click)="onDownloadContractPdf()" [disabled]="!transaction">
            </app-audi-button>
            <br /><br />
            <app-audi-text variant="order4" className="audi-type-normal" text="If you still have any questions or need help with anything, please contact our Customer Care Centre. Please have your contract number on hand: {{transaction?.sapContractNumber}}
            
            South Africa: 0860 434 737
            Swaziland, Lesotho, Namibia and Botswana: +27 41 994 5615"></app-audi-text>
        </div>
        <!--unsuccessful purchase-->
        <div [hidden]="!visibleElements['PaymentFailure']">
            <app-audi-text variant="order4" className="audi-type-normal" text="Unfortunately your bank has declined the transaction and it cannot be completed. This could be due to a number of reasons and we recommend you contact your bank.

                You have not been billed.
                
                If you would like to choose a different Freeway Vehicle Plan please click here:">
            </app-audi-text>
            <br /><br />
            <app-audi-button text="View Quotation" (click)="onShowViewQuote()" [disabled]="!ownerInfo">
            </app-audi-button>
            <br /><br />
            <app-audi-text variant="order4" className="audi-type-normal" text="If you still have any questions or need help with anything, please contact our Customer Care Centre.

            South Africa: 0860 434 838"></app-audi-text>
        </div>
        <!--User Cancelled-->
        <div [hidden]="!visibleElements['UserCancelled']">
            <app-audi-text variant="order4" className="audi-type-normal" text="The transaction has been cancelled and you have not been billed.

            If you would like to choose a different Freeway Plan please click here:">
            </app-audi-text>
            <br /><br />
            <app-audi-button text="Select Plan" (click)="onShowSelectPlan()" [disabled]="!ownerInfo">
            </app-audi-button>
            <br /><br />
            <app-audi-text variant="order4" className="audi-type-normal" text="If you still have any questions or need help with anything, please contact our Customer Care Centre.

            South Africa: 0860 434 838"></app-audi-text>
        </div>
        <!--PayU Error-->
        <div [hidden]="!visibleElements['PayUError']">
            <app-audi-text variant="order4" className="audi-type-normal"
                text="Unfortunately we can’t confirm your transaction at this time. You should receive an email confirming your new Freeway contract within the hour, but if for some reason there is a problem, our team will be in contact with you.">
            </app-audi-text>
            <br /><br />
            <app-audi-text variant="order4" className="audi-type-normal" text="If you still have any questions or need help with anything, please contact our Customer Care Centre.

            South Africa: 0860 434 838"></app-audi-text>
        </div>
        <!--PayU Timeout-->
        <div [hidden]="!visibleElements['PayUTimeout']">
            <app-audi-text variant="order4" className="audi-type-normal" text="The transaction has timed out.

            If you would like to choose a different Freeway Plan please click here:">
            </app-audi-text>
            <br /><br />
            <app-audi-button text="Select Plan" (click)="onShowSelectPlan()" [disabled]="!ownerInfo">
            </app-audi-button>
            <br /><br />
            <app-audi-text variant="order4" className="audi-type-normal" text="If you still have any questions or need help with anything, please contact our Customer Care Centre.

            South Africa: 0860 434 838"></app-audi-text>
        </div>
    </div>
    <div *ngIf="visibleElements['CancelContract']">
        <br />
        <app-audi-button text="Cancel Contract" (click)="onCancelContract()" [disabled]="!transaction">
        </app-audi-button>
    </div>
    <div *ngIf="visibleElements['RefundTransaction']">
        <br />
        <app-audi-button text="Refund Transaction" (click)="onRefundTransaction()" [disabled]="!transaction">
        </app-audi-button>
    </div>
</div>